import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'

import { useSyncProjectFields } from '../use-site-actions'

type SyncButtonProps = {
  siteId: string
}

const SyncButton = ({ siteId }: SyncButtonProps) => {
  const { t } = useTranslation()
  const { sync, loading } = useSyncProjectFields(siteId)

  return (
    <Button
      variant="outlined"
      size="small"
      fullWidth
      disabled={loading}
      onClick={sync}
      startIcon={<i className={`fa-regular fa-arrows-rotate${loading ? ' fa-spin' : ''}`} aria-hidden="true" />}
    >
      {t('admin_sites.card.sync')}
    </Button>
  )
}

export default SyncButton
